import type { WordConnectWordDto } from '../services/api';

/** Board geometry only — answer text is never sent by the API during play. */
export function wordConnectWordLength(w: WordConnectWordDto): number {
  if (w.length > 0) return w.length;
  return w.text.length;
}
